module.exports = __webpack_public_path__ + "media/images/slides/babel1-0a64ac65c9bc77d8e86812e20a890c61.jpg";